import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const scrollToElement = (elementId: string) => {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    element?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 100);
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
